import MainLayout from "../components/Layouts/MainLayout";
import RoomDashBoard from "../components/RoomDashBoard";

export default function RoomDashBoardPage() {
  return (
    <MainLayout activeId="dashboard" isRoomView={true}>
      <RoomDashBoard />
    </MainLayout>
  );
}
